import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { companyInfo } from '../data/mock';
import { ShieldCheck, Cookie, Mail, MapPin, FileText, UserCheck, Globe2 } from 'lucide-react';

const PrivacyPolicy = () => {
  const { t } = useLanguage();
  return (
    <div className="min-h-screen bg-[#F7F4EE]" data-testid="privacy-policy-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <div className="forest-panel rounded-3xl p-8 sm:p-10 shadow-xl">
          <div className="flex items-center gap-3 text-[#1F3D2B] mb-4">
            <ShieldCheck className="w-6 h-6" />
            <span className="text-sm font-semibold uppercase tracking-wide">{t('privacy.badge', 'Privātuma politika')}</span>
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-[#2E2E2E] mb-4" data-testid="privacy-title">
            {t('privacy.title', 'Sila Meži privātuma politika')}
          </h1>
          <p className="text-[#2E2E2E]/70 mb-8" data-testid="privacy-intro">
            {t('privacy.intro', 'Mēs rūpējamies par Jūsu datu drošību un privātumu. Šajā politikā skaidrojam, kādus datus apstrādājam un kāpēc.')}
          </p>

          <div className="space-y-8 text-[#2E2E2E]/80">
            <section>
              <h2 className="text-xl font-semibold text-[#1F3D2B] mb-3 flex items-center gap-2">
                <UserCheck className="w-5 h-5" /> {t('privacy.controllerTitle', 'Datu pārzinis')}
              </h2>
              <p>{companyInfo.legalName}</p>
              <p>{t('privacy.controllerRegLabel', 'Reģ. Nr.:')} {companyInfo.regNumber}</p>
              <p>{t('privacy.controllerAddressLabel', 'Adrese:')} {companyInfo.address}</p>
              <p>{t('privacy.controllerEmailLabel', 'E-pasts datu jautājumiem:')} {companyInfo.email}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#1F3D2B] mb-3 flex items-center gap-2">
                <FileText className="w-5 h-5" /> {t('privacy.dataTitle', 'Kādi dati tiek apstrādāti')}
              </h2>
              <ul className="list-disc list-inside space-y-2" data-testid="privacy-data-list">
                <li>{t('privacy.dataItemContact', 'Kontaktu formā iesniegtie dati (vārds, e-pasts, tālrunis, ziņa).')}</li>
                <li>{t('privacy.dataItemVisits', 'Apmeklējumu uzskaite pēc sīkdatņu piekrišanas (IP adrese, reģions, apmeklējuma laiks).')}</li>
                <li>{t('privacy.dataItemEmail', 'E-pastu nosūtīšanas dati, izmantojot Resend servisu.')}</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#1F3D2B] mb-3 flex items-center gap-2">
                <Globe2 className="w-5 h-5" /> {t('privacy.visitsTitle', 'Apmeklējumu uzskaite')}
              </h2>
              <p>{t('privacy.visitsText', 'Apmeklējumu uzskaite tiek veikta tikai pēc Jūsu sīkdatņu piekrišanas. Reģiona noteikšanai izmantojam IPinfo servisu.')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#1F3D2B] mb-3 flex items-center gap-2">
                <Cookie className="w-5 h-5" /> {t('privacy.cookiesTitle', 'Sīkdatnes')}
              </h2>
              <p>{t('privacy.cookiesText', 'Šī vietne izmanto nepieciešamās, funkcionalitātes un statistikas sīkdatnes, lai nodrošinātu vietnes darbību, uzlabotu lietošanas pieredzi un saprastu apmeklējumu tendences.')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#1F3D2B] mb-3 flex items-center gap-2">
                <Mail className="w-5 h-5" /> {t('privacy.retentionTitle', 'Datu glabāšana un tiesības')}
              </h2>
              <p>{t('privacy.retentionText', 'Dati tiek glabāti tik ilgi, cik tas nepieciešams pakalpojumu nodrošināšanai vai likumā noteiktā kārtībā. Jums ir tiesības pieprasīt savu datu labošanu vai dzēšanu, rakstot uz augstāk norādīto e‑pasta adresi.')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#1F3D2B] mb-3 flex items-center gap-2">
                <MapPin className="w-5 h-5" /> {t('privacy.thirdPartyTitle', 'Trešo pušu pakalpojumi')}
              </h2>
              <p>{t('privacy.thirdPartyText', 'Reģiona noteikšanai izmantojam IPinfo, bet e‑pastu piegādei Resend. Trešās puses datus apstrādā atbilstoši savām privātuma politikām.')}</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
